// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"dbd943c3","134":"9550dcef","147":"b28b7003","152":"146ca88d","198":"5c830e18","362":"6e4a8f40","404":"3ac5f455","480":"5324ddbb","541":"e196654d","579":"77ec721f","732":"5f6d39dd","854":"69aa74ee"}[chunkId] + ".chunk.js";
};